import { api } from "@/lib/api";

export async function listNotifications({ limit = 30, only_unread = false } = {}) {
  const { data } = await api.get(`/notifications`, { params: { limit, only_unread } });
  return data;
}

export async function unreadNotificationsCount() {
  const { data } = await api.get(`/notifications/unread-count`);
  return data.unread || 0;
}

export async function markNotificationRead(id) {
  const { data } = await api.post(`/notifications/${id}/read`);
  return data.notification;
}

export async function markAllNotificationsRead() {
  const { data } = await api.post(`/notifications/read-all`);
  return data.updated;
}
